import { render } from "./PurchaseRequestList.vue?vue&type=template&id=7474917e&scoped=true"
import script from "./PurchaseRequestList.vue?vue&type=script&lang=js"
export * from "./PurchaseRequestList.vue?vue&type=script&lang=js"

import "./PurchaseRequestList.vue?vue&type=style&index=0&id=7474917e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7474917e"]])

export default __exports__